module.exports = "<div class=\"lpview_cke_wrapper rich_text_editor_container\"><textarea class=\"lpview_form_textarea form_textarea\"></textarea></div>";